import { useState } from 'preact/hooks';
import { CSSProperties } from 'preact/compat';

import cx from 'clsx';

import style from './Loader.module.scss';

export type ThemeColor = {
	primary: string;
	secondary: string;
	tertiary: string;
	primaryLight: string;
};

interface ILoader {
	width?: string;
	height?: string;
	styles?: CSSProperties;
	className?: string;
	id?: string;
	theme?: ThemeColor | null;
}

export const DEFAULT_THEME: ThemeColor = {
	primary: 'rgb(95, 37, 159)',
	secondary: 'rgb(201, 139, 219)',
	tertiary: 'rgb(0, 71, 187)',
	primaryLight: 'rgb(236, 221, 240)',
	primaryLabel: 'rgb(255, 255, 255)',
	labelDark: 'rgb(0, 0, 0)',
};

const Loader = ({
	width = '119.34px',
	height = '45.32px',
	theme,
	styles = {},
	className = '',
	...rest
}: ILoader) => {
	const [key, setKey] = useState(0);

	const handleAnimationEnd = () => {
		setKey(key + 1);
	};

	const currenTheme: ThemeColor = {
		...DEFAULT_THEME,
		...theme,
	};

	return (
		<div
			id="loader"
			className={cx(style.container, className)}
			key={key}
			style={{
				...styles,
				'--width': width,
				'--height': height,
				'--first-circle': currenTheme.primary,
				'--second-circle': currenTheme.secondary,
				'--third-circle': currenTheme.tertiary,
				'--light-second-pallet': currenTheme.primary,
			}}
			{...rest}
		>
			{/* <!-- first rgb(95,37,159) --> */}
			<div className={`${style.circle} ${style.firstCircle}`} />
			<div className={`${style.circle} ${style.emptyCircle}`} />
			<div
				className={`${style.runner} ${style.gluedRunner} ${style.firstRunner}`}
			/>
			<div className={`${style.runner} ${style.regularFirstRunner}`} />
			<div className={`${style.runner} ${style.regularSecondRunner}`} />

			{/* <!-- second rgb(201,139,219) --> */}
			<div className={`${style.circle} ${style.secondCircle}`} />
			<div
				className={`${style.runner} ${style.gluedRunner} ${style.secondRunner}`}
			/>
			<div
				className={`${style.runner} ${style.regularFirstRunner} ${style.secondRegularFirstRunner}`}
			/>
			<div
				className={`${style.runner} ${style.regularSecondRunner} ${style.secondRegularSecondRunner}`}
			/>

			{/* <!-- third rgb(0,71,187) --> */}
			<div className={`${style.circle} ${style.thirdCircle}`} />
			<div
				className={`${style.runner} ${style.gluedRunner} ${style.thirdRunner}`}
			/>
			<div
				className={`${style.runner} ${style.regularFirstRunner} ${style.thirdRegularFirstRunner}`}
			/>
			<div
				className={`${style.runner} ${style.regularSecondRunner} ${style.thirdRegularSecondRunner}`}
			/>

			{/* <!-- fourth rgb(0,71,187) --> */}
			<div className={`${style.circle} ${style.fourthCircle}`} />
			<div
				className={`${style.runner} ${style.gluedRunner} ${style.fourthRunner}`}
			/>
			<div
				className={`${style.runner} ${style.regularFirstRunner} ${style.fourthRegularFirstRunner}`}
			/>
			<div
				className={`${style.runner} ${style.regularSecondRunner} ${style.fourthRegularSecondRunner}`}
				onAnimationEnd={handleAnimationEnd}
			/>
		</div>
	);
};

export default Loader;
